export default __webpack_public_path__ + "static/media/screen_livechat_02.95c15fc5.png";